import { render, staticRenderFns } from "./CourseItemCombo.vue?vue&type=template&id=97392d02"
import script from "./CourseItemCombo.vue?vue&type=script&lang=js"
export * from "./CourseItemCombo.vue?vue&type=script&lang=js"
import style0 from "./CourseItemCombo.vue?vue&type=style&index=0&id=97392d02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports